<template>
  <div @click="$emit('clickPicture')">
    <div v-if="url" class="image-profile">
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 200 200"
      >
        <title>{{ title }}</title>
        <defs>
          <pattern
            :id="`img#${url}${hash}`"
            patternUnits="userSpaceOnUse"
            width="200"
            height="200"
          >
            <image
              :xlink:href="url"
              x="0"
              y="0"
              width="200"
              height="200"
            />
          </pattern>
        </defs>
        <circle
          :fill="`url(#img#${url}${hash})`"
          r="96"
          cy="100"
          cx="100"
        />
      </svg>
    </div>
    <div v-else-if="uuid && mediaImageUrl">
      <div class="image-profile">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 200 200"
        >
          <title>{{ title }}</title>
          <defs>
            <pattern
              :id="`img#${userId}${hash}`"
              patternUnits="userSpaceOnUse"
              width="200"
              height="200"
            >
              <image
                :xlink:href="mediaImageUrl"
                x="0"
                y="0"
                width="200"
                height="200"
              />
            </pattern>
          </defs>
          <circle
            :fill="`url(#img#${userId}${hash})`"
            r="96"
            cy="100"
            cx="100"
          />
        </svg>
      </div>
    </div>
    <div v-else class="image-profile pin--image no-profile-picture">
      <rounded-image :text="userFirstname" :title="title" />
    </div>
  </div>
</template>

<script>
import { checkThenGetImageUrl } from '@tools/media-image';
import RoundedImage from './RoundedImage.vue';

/**
 * @deprecated Use `UserPicture.vue` instead
 */
export default {
  components: { RoundedImage },
  props: {
    uuid: { type: String, default: '' },
    title: { type: String, default: '' },
    url: { type: String, default: '' },
    userId: { type: Number, default: 0 },
    userFirstname: { type: String, default: '' },
  },
  data() {
    return {
      hash: Math.floor(Math.random() * 10000),
      mediaImageUrl: null,
    };
  },
  watch: {
    uuid() {
      this.fetchMediaImageUrl();
    },
  },
  async mounted() {
    await this.fetchMediaImageUrl();
  },
  methods: {
    async fetchMediaImageUrl() {
      if (this.uuid && this.uuid !== '') {
        this.mediaImageUrl = await checkThenGetImageUrl(this.uuid, 'webp', 105, null, [ 105, 105 ], [ 1, 1 ]);
      }
    },
  },
};
</script>
